(ns app.front.view.group.admin.import.form-field
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.import.common :as import-session-common]
            [app.front.view.group.admin.import.subs :as import-subs]
            [core.front.event :refer [<sub >evt]]
            [reagent.core :as r]))

(defn form-field-mapping-settings [{:keys [group-id session-id ix settings target]}]
  (r/with-let [*settings (r/atom settings)]
    (let [tr              (<sub [:tr])
          {:keys [label]} @*settings]
      [:div.mt-2.max-w-md.ml-16
       [ui/text-input {:label-text (tr [:data-import/form-field-name])
                       :value      label
                       :disabled   (not (<sub [::import-subs/is-draft? session-id]))
                       :on-change  (fn [e]
                                     (let [new-val (futil/tval e)]
                                       (swap! *settings assoc :label new-val)
                                       (>evt [::import-subs/set-mapping-debounce
                                              {:authority-group-id group-id
                                               :session-id         session-id
                                               :col-ix             ix
                                               :mapping-key        target
                                               :settings           @*settings}])))}]])))

(defmethod import-session-common/mapping-settings :data-import.mapping/form-field [ctx]
  (form-field-mapping-settings ctx))

(defmethod import-session-common/mapping-settings :data-import.mapping/date-field [ctx]
  (form-field-mapping-settings ctx))
